// common type declaration for themes used by emotion https://emotion.sh/docs/typescript#define-a-theme
export var colors = [
    "primary",
    "primary70",
    "primary100",
    "primaryHighlight",
    "primaryGradient1",
    "secondary100",
    "secondary70",
    "secondaryHighlight",
    "natural100",
    "natural70",
    "natural50",
    "natural40",
    "natural30",
    "natural20",
    "natural10",
    "natural0",
    "info",
    "error",
    "warning",
    "success",
    /** @deprecated */ "warning20", 
];
export var gradients = [
    "green",
    "orange",
    "mint",
    "brand",
    "natural",
    "warning",
    "naturalLight", 
];
var breakpoints = [
    "xxs",
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
var spacingKeys = [
    0,
    5,
    10,
    20,
    30,
    40,
    50,
    60,
    70,
    80,
    90,
    100,
    110,
    120,
    130,
    140,
    150, 
];
